import {createContext,useCallback,useContext,useMemo,useState} from "react"
import {signIn,logOut,getCurrentUser} from "../firebase.js"

const Context = createContext()
export default function AuthProvider({ children }){
    const [currentUser, setCurrentUser] = useState(null)

    const login = useCallback(()=> signIn().then(()=>setCurrentUser), [])
    const logout =useCallback(()=>logOut().then(()=>setCurrentUser(null)), [])
    const authenticate=useCallback(()=>getCurrentUser().then(setCurrentUser), [])
    const value = useMemo(() => {
        return {login,logout,authenticate,currentUser}
    }, [login, logout, currentUser, authenticate])
    return <Context.Provider value={value}>{children}</Context.Provider>
}
export function useAuthContext(){
    return useContext(Context)
}